import { useState } from "react";

import { CitationSVG, Icon } from "@newsela/angelou";
import { actionNames } from "@newsela/snitch";

import { ContentLevel } from "@/types/models/ContentLevel.interface";
import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton";

import { IContentData } from "./CitationAction.interface";
import { iconCss } from "./CitationAction.style";
import CitationModal from "./CitationModal";

interface CitationActionProps {
  currentLevel: ContentLevel | undefined;
  disabled: boolean;
  hoverLabel: string;
  contentData?: IContentData | undefined;
}
export const CitationAction = ({
  contentData,
  currentLevel,
  disabled,
  hoverLabel,
}: CitationActionProps) => {
  const [isCitationModalOpen, setIsCitationModalOpen] = useState(false);
  const icon = <Icon __cssFor={{ root: iconCss }} SvgComponent={CitationSVG} />;

  const ariaProps = { "aria-label": "Citation" };

  const eventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName: actionNames.start,
    streamProperties: {
      content_type: "Citation",
      description: "Open Citation pop-up",
    },
  };

  const handleClick = () => setIsCitationModalOpen(true);

  return contentData ? (
    <>
      <SecondaryActionButton
        ariaProps={ariaProps}
        dataProps={{ "data-qa-selector": "show-citation" }}
        disabled={disabled}
        eventProperties={eventProperties}
        hoverLabel={hoverLabel}
        icon={icon}
        onClick={handleClick}
        title="Citation"
      />
      <CitationModal
        active={isCitationModalOpen}
        setActive={setIsCitationModalOpen}
        contentData={contentData}
        currentLevel={currentLevel}
      />
    </>
  ) : (
    <></>
  );
};

export default CitationAction;
